<template lang="html">
  <div class="handling-card">
    <div class="add-by-saved-routes">
      <span class="span-left" v-if="showDelHandling" @click="delHandling"
        >删除</span
      >
      <span class="span-left" @click="addToCommonUse">添加到常用路线</span>
      <span @click="addByCommonRoutes">从常用路线添加</span>
    </div>
    <div class="handling-wrapper">
      <div class="left same-input">
        <div class="same-logo">
          起
        </div>
        <div class="same-content">
          <el-form-item label="" :prop="`${cardKey}.startContactName`">
            <el-input
              v-model="ruleForm[cardKey].startContactName"
              :placeholder="getInputText('startContactName')"
            ></el-input>
          </el-form-item>
          <el-form-item label="" :prop="`${cardKey}.startContactPhone`">
            <el-input
              v-model="ruleForm[cardKey].startContactPhone"
              :placeholder="getInputText('startContactPhone')"
            ></el-input>
          </el-form-item>
          <el-form-item label="" :prop="`${cardKey}.startPoint`">
            <el-input
              v-model="ruleForm[cardKey].startPoint"
              :placeholder="getInputText('startPoint')"
              @focus="showAddressSelect(`${cardKey}.startPoint`)"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="ruleForm[cardKey].expectDeliveryTime"
              type="datetime"
              :placeholder="getInputText('expectDeliveryTime')"
              style="width:100%;"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </div>
      <div class="right same-input">
        <div class="same-logo">
          终
        </div>
        <div class="same-content">
          <el-form-item label="" :prop="`${cardKey}.endContactName`">
            <el-input
              v-model="ruleForm[cardKey].endContactName"
              :placeholder="getInputText('endContactName')"
            ></el-input>
          </el-form-item>
          <el-form-item label="" :prop="`${cardKey}.endContactPhone`">
            <el-input
              v-model="ruleForm[cardKey].endContactPhone"
              :placeholder="getInputText('endContactPhone')"
            ></el-input>
          </el-form-item>
          <el-form-item label="" :prop="`${cardKey}.endPoint`">
            <el-input
              v-model="ruleForm[cardKey].endPoint"
              :placeholder="getInputText('endPoint')"
              @focus="showAddressSelect(`${cardKey}.endPoint`)"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="ruleForm[cardKey].expectArrivalTime"
              type="datetime"
              :placeholder="getInputText('expectArrivalTime')"
              style="width:100%;"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </div>
    </div>
    <div class="btn-wrap">
      <span @click="addGoods(cardKey)">添加货物</span>
    </div>
    <el-card class="goods-card">
      <div class="goods-info">
        <div
          class="goods-info-card"
          v-for="(itemChild, itemIndex) in ruleForm[cardKey].goods"
          :key="itemIndex"
        >
          <div class="goods-info-title">
            <span class="left-span"
              >装卸信息{{ cardKey + 1 }} / 货物信息{{ itemIndex + 1 }}</span
            >
            <span
              class="right-span"
              v-if="ruleForm[cardKey].goods.length > 1"
              @click="goodsDel(cardKey, itemIndex)"
              >删除</span
            >
          </div>
          <!-- 货物容器 -->
          <goods-card
            :cardKey="cardKey"
            :itemIndex="itemIndex"
            :ruleForm="ruleForm"
            :key="tempGoodsKey"
          />
        </div>
      </div>
    </el-card>
    <!-- 添加货物弹窗 -->
    <add-goods-dialog
      :dialogVisible.sync="goodsVisible"
      :selectedGoodsIds="selectedGoodsIds"
      @addGoodsSuccess="obj => $emit('addGoodsSuccess', obj)"
    />
    <!-- 选择地址弹窗 -->
    <select-address-dialog
      :dialogVisible.sync="selectAddressVisible"
      @getAddress="getAddress"
    />
    <!-- 添加到常用路线弹窗 -->
    <common-routes-dialog
      :dialogVisible.sync="commonRoutesVisible"
      @success="routesSelected"
    />
  </div>
</template>

<script>
import addGoodsDialog from "@/views/personal/deliver/components/handlingWrapper/components/addGoodsDialog";
import selectAddressDialog from "@/views/personal/deliver/components/handlingWrapper/components/selectAddressDialog";
import goodsCard from "@/views/personal/deliver/components/handlingWrapper/components/goodsCard";
import commonRoutesDialog from "@/views/personal/deliver/components/handlingWrapper/components/commonRoutesDialog";
import {
  handlingItemPlaceholder,
  goodsItemPlaceholder,
  getInputText
} from "@/views/personal/deliver/components/handlingWrapper/config";
import qs from "qs";

export default {
  props: {
    cardKey: {
      type: Number,
      default: 0
    },
    showDelHandling: {
      type: Boolean,
      default: false
    },
    ruleForm: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      goodsVisible: false,
      selectAddressVisible: false,
      commonRoutesVisible: false,
      handlingItemPlaceholder,
      goodsItemPlaceholder,
      currentIndex: -1,
      currentIndexAndKey: "",
      tempGoodsKey: new Date().getTime(),
      selectedGoodsIds: []
    };
  },
  computed: {},
  created() {},
  methods: {
    delHandling() {
      this.$emit("delHandling");
    },
    routesSelected(obj) {
      this.ruleForm[this.cardKey] = { ...this.ruleForm[this.cardKey], ...obj };
    },
    addByCommonRoutes() {
      this.commonRoutesVisible = true;
    },
    addToCommonUse() {
      this.$emit("addToCommonUse", { currentIndex: this.cardKey });
    },
    async doAddConfirm() {
      await this.$myConfirm("确定添加到常用路线吗", this);
      this.doRealAdd();
    },
    async doRealAdd() {
      let tempObj = {},
        obj = this.ruleForm[this.cardKey];
      Object.keys(obj).map(item => {
        if (/^(start|end)/.test(item)) {
          tempObj[item] = obj[item];
        }
      });
      await this.$http.post(
        "/shipper/order-shipper/often-add",
        qs.stringify(tempObj)
      );
      this.$message({
        type: "success",
        message: "常用路线添加成功"
      });
    },
    getAddress(val) {
      let {
        location,
        address: { address, city, district, province }
      } = val;
      let [index, key] = this.currentIndexAndKey.split(".");
      let str = key === "startPoint" ? "start" : "end";
      Object.assign(this.ruleForm[index], {
        [key]: address,
        [str + "PointCity"]: city,
        [str + "PointDistrict"]: district,
        [str + "PointProvince"]: province,
        [str + "PointLocation"]: location
      });
    },
    getInputText,
    showAddressSelect(key) {
      this.currentIndexAndKey = key;
      this.selectAddressVisible = true;
    },
    showGoodsDialog(index) {
      this.selectedGoodsIds = this.ruleForm[index].goods.map(
        item => item.goodsCategoryid
      );
      this.goodsVisible = true;
    },
    async addGoods(currentIndex) {
      this.$emit("addGoodsValidate", { currentIndex });
    },
    goodsDel(cardKey, itemIndex) {
      this.tempGoodsKey = new Date().getTime();
      this.$emit("goodsDel", { bigIndex: cardKey, index: itemIndex });
    }
  },
  watch: {},
  components: {
    addGoodsDialog,
    goodsCard,
    commonRoutesDialog,
    selectAddressDialog
  }
};
</script>

<style lang="scss">
.handling-card {
  .add-by-saved-routes {
    display: flex;
    flex-direction: row-reverse;
    span {
      color: #00a7f7;
      cursor: pointer;
      &.span-left {
        margin-left: 20px;
      }
    }
  }
  .handling-wrapper {
    padding: 20px 0;
    display: flex;
    .left {
      flex: 1;
      .same-logo {
        background: #00a7f7;
      }
    }
    .right {
      flex: 1;
      .same-logo {
        background: #f56c6c;
      }
    }
    .same-input {
      display: flex;
      align-items: center;
      .same-logo {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        color: #fff;
        margin: 0 30px 0 10px;
      }
      .same-content {
        flex: 1;
        padding-right: 20px;
        .shipper-info-top {
          margin: 12px 0;
        }
      }
    }
  }
  .btn-wrap {
    display: flex;
    flex-direction: row-reverse;
    padding-bottom: 14px;
    span {
      cursor: pointer;
      color: #00a7f7;
    }
  }
  .goods-card {
    .el-card__body {
      padding: 0 0 10px 0;
      .goods-info {
        padding: 20px 20px 20px 20px;
        &-card:not(:last-child) {
          padding-bottom: 20px;
        }
        &-title {
          padding-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left-span {
            font-size: 16px;
          }
          .right-span {
            font-size: 12px;
            cursor: pointer;
            color: #f56c6c;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/deliver/components/handlingWrapper/components/handlingCard/index.vue